import { RootState } from "../reducers";

export const getBottomState = ({ layout: { bottomState } }: RootState) => bottomState;

export const getBottomHeight = ({ layout: { bottomHeight } }: RootState) => bottomHeight;

export const getPanelWidth = ({ layout: { panelWidth } }: RootState) => panelWidth;

export const getShowMapLegend = ({ layout: { showMapLegend } }: RootState) => showMapLegend;

export const getAdditionalPanelVisibility = ({ layout: { isVisibleAdditionControl } }: RootState) =>
  isVisibleAdditionControl;

export const getIsNirvanaMode = ({ layout: { isNirvanaMode } }: RootState) => isNirvanaMode;

export const getIsPresentationMode = ({ layout: { isPresentationMode } }: RootState) => isPresentationMode;
